/* unplugin-vue-components disabled */import { render } from "./memory-item.vue?vue&type=template&id=9e1f0f2e&scoped=true"
import script from "./memory-item.vue?vue&type=script&lang=js"
export * from "./memory-item.vue?vue&type=script&lang=js"

import "./memory-item.vue?vue&type=style&index=0&id=9e1f0f2e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e1f0f2e"],['__file',"src/pages/settings/memory/memory-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9e1f0f2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9e1f0f2e', __exports__)) {
    api.reload('9e1f0f2e', __exports__)
  }
  
  module.hot.accept("./memory-item.vue?vue&type=template&id=9e1f0f2e&scoped=true", () => {
    api.rerender('9e1f0f2e', render)
  })

}


export default __exports__